export const extensionRegEx = /(?:\.([^.]+))?$/;
export const htmlStyleRegex = /<style([\s\S]*?)<\/style>/gi;
